import { Show, type JSX } from "solid-js";

/** One heading style for every RACE SUMMARY section: title, a line saying what it shows, and an
 *  optional control area on the right (e.g. the course view's colour toggle). */
export default function SectionHead(props: { title: string; subtitle?: string; children?: JSX.Element }) {
  return (
    <header class="race-section-head">
      <div class="race-section-head-text">
        <h2 class="race-section-title">{props.title}</h2>
        <Show when={props.subtitle}>
          <p class="race-section-subtitle">{props.subtitle}</p>
        </Show>
      </div>
      <Show when={props.children}>
        <div class="race-section-head-controls">{props.children}</div>
      </Show>
    </header>
  );
}
